// Unpublished Work © 2025 Deere & Company.

export const WORK_PLAN_SMALL_THRESHOLD = 50;
export const WORK_PLAN_MEDIUM_THRESHOLD = 500;
export const WORK_PLAN_LARGE_THRESHOLD = 1000;
export const WORK_PLAN_EXTRA_LARGE_THRESHOLD = 10000;

export const FIELDS_SMALL_THRESHOLD = 50;
export const FIELDS_MEDIUM_THRESHOLD = 100;
export const FIELDS_LARGE_THRESHOLD = 500;
export const FIELDS_EXTRA_LARGE_THRESHOLD = 1000;

export const SIZE_SMALL = 'small';
export const SIZE_MEDIUM = 'medium';
export const SIZE_LARGE = 'large';
export const SIZE_EXTRA_LARGE = 'xlarge';

export const APP_LOAD = 'app-load';
export const DATA_LOAD = 'data-load';
export const APP_LOAD_STEP = 'persistent-header-loaded';
export const FIELDS_STEP = 'fields';
export const BOUNDARIES_STEP = 'boundaries';
export const WORK_PLAN_STEP = 'workplan';
export const WORK_PLANS_STEP = 'workplans';
export const IMPLEMENTS_STEP = 'implements';
export const MACHINES_STEP = 'machines';
export const OPERATORS_STEP = 'operators';
export const CROPS_STEP = 'crops';
export const VARIETIES_STEP = 'varieties';
export const DRY_BLENDS_STEP = 'dry-blends';
export const TANK_MIXES_STEP = 'tank-mixes';
export const CHEMICALS_STEP = 'chemicals';
export const FERTILIZERS_STEP = 'fertilizers';
export const TIME_ESTIMATE_STEP = 'time-estimate';

export const RX_STEP = 'prescriptions';
